import http from './http'

class ManageInvoice {
  changeStatus (payload) {
    return http.post('/manager_invoices', payload)
  }

  sendDocs (payload) {
    return http.post('/manage_invoice_documents/new', payload)
  }

  changeStatusDoc (payload) {
    return http.put('/manage_invoice_documents/change_status', payload)
  }
}

export default new ManageInvoice()



// WEBPACK FOOTER //
// ./src/services/manage_invoice.js